export default {"src":"/_next/static/media/logo2.7f3599ed.svg","height":333,"width":350,"blurWidth":0,"blurHeight":0};